import { useQuery } from "@tanstack/react-query";
import { getCustomerProfile } from "../../service/query/auth";

export const useGetCustomerProfile = ({ membership_id }) => {
  return useQuery({
    queryKey: ["customerProfile", membership_id],
    queryFn: () => getCustomerProfile({ membership_id }),
    enabled: !!membership_id,
  });
};